import { render, staticRenderFns } from "./Embroidery.vue?vue&type=template&id=c4d7cfe0"
import script from "./Embroidery.vue?vue&type=script&lang=js"
export * from "./Embroidery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports